import { browser } from '$app/environment';
import type { Track } from '$lib/models/track';

class AttributeUsModalState {
  public visible = $state(false);
  public track: Track = $state({} as Track);
  public disableButton = $state(true);

  show(track: Track, disableButton: boolean) {
    if (!browser) return;
    this.track = track;
    this.visible = true;
    this.disableButton = disableButton;
  }

  hide() {
    if (!browser) return;
    this.visible = false;
  }
}

export const attributeUsModal = new AttributeUsModalState ();